document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis({ autoRaf: true, duration: 2.4, smoothWheel: true, wheelMultiplier: 2, });
  const navbar = document.querySelector(".component_navbar_section");
  const wrapper = document.querySelector(".navbar-wrapper");

  if (navbar && wrapper) {
    wrapper.style.setProperty("--navbar-height", navbar.offsetHeight + "px");
  }
});

window.addEventListener("scroll", () => {
  const announcementBar = document.querySelector(".announcement-bar-section");
  const navbar = document.querySelector(".component_navbar_section");
  if (!navbar) return;

  const offset = announcementBar ? announcementBar.offsetHeight : 0;

  const isHomepage =
    window.location.pathname === "/" 
    window.location.pathname === "/index" 
    window.location.pathname === "/index.html";

  if (window.scrollY > offset) {
    // Sticky behavior for ALL pages
    navbar.classList.add("is-fixed");
    navbar.classList.remove("not-fixed");

    navbar.style.position = "fixed";
    navbar.style.top = "0";
    navbar.style.left = "0";
    navbar.style.right = "0";
    navbar.style.backgroundColor = "#0d0e0e";
  } else {
    // NOT sticky
    navbar.classList.add("not-fixed");
    navbar.classList.remove("is-fixed");
  navbar.style.backgroundColor = "rgba(0,0,0,0)";
    if (isHomepage) {
      // ✅
//  your required homepage behavior
      navbar.style.position = "absolute";
      navbar.style.top = "auto";
      navbar.style.left = "0";
      navbar.style.right = "0";
      navbar.style.backgroundColor = "rgba(0,0,0,0)";
    } else {
      // Other pages
      navbar.style.position = "static";
      navbar.style.top = "auto";
      navbar.style.backgroundColor = "rgba(0,0,0,0)";
    }
  }
});



$(document).ready(function () {
  console.log('JS Loaded');
  setTimeout( () => {
    let reviewBox = document.querySelector('.jdgm-prev-badge');
    let impressions = reviewBox.attributes.getNamedItem('data-number-of-reviews');
    if( impressions.value != 0 ) {
      let divider = document.getElementsByClassName('custom-productt__price-review-spacer');
      divider[0].style.display = 'block';
    }
  }, 100);
  // if (reviewBox[0].hasAttribute('data-impressions-tracked')) {
  //   console.log('with review!');
  // } else {
  //   console.log('without review');
  // }
  //video slider play button
  $('.home_backing_card').each(function (index) {
    const $card = $(this);
    const $video = $card.find('video');
    const $playBtn = $card.find('.home_backing_icon');

    if ($video.length && $playBtn.length) {
      console.log("button or video found");

      $playBtn.on('click', function () {
        $video.get(0).play();

        requestAnimationFrame(() => {
          $playBtn.addClass('hidden');
        });
      });

      $video.on('pause', function () {
        $playBtn.removeClass('hidden');
      });

      $video.on('play', function () {
        $playBtn.addClass('hidden');
      });
    } else {
      console.log("no button found or video");
    }
  });
});


// if from Webflow and it doesn't need to be dom ready the below this line


const initSlider = (identifier, config, breakpoint) => {
    let slider = null;
    if (breakpoint) {
      const runOnMatch = (media) => {
        if (media.matches && !slider) {
          config.init = false;
          slider = new Swiper(identifier, config);
          slider.init();
        }
        if (!media.matches && slider) {
          slider.destroy();
          slider = null;
        }
      };
      const media = window.matchMedia(
        `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
          breakpoint >= 0 ? breakpoint : breakpoint * -1
        }px)`
      );
      runOnMatch(media);
      window.addEventListener("resize", () => {
        runOnMatch(media);
      });
      media.addEventListener("change", runOnMatch);
    } else {
      slider = new Swiper(identifier, config);
    }
  };

document.addEventListener('DOMContentLoaded', () => {
 //Swiper (Best Seller)
    initSlider("#best-seller", {
      slidesPerView: 2,
      speed: 500,
	  loop: true,
      navigation: {
        nextEl: '#best-seller-next',
        prevEl: '#best-seller-prev',
       },
      pagination: {
        el: '#best-seller-pagination',
        bulletActiveClass: "is-active",
        bulletClass: "swiper_dots",
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 16
        },
        992: {
          slidesPerView: "auto",
          spaceBetween: 16
        }
      }
    });
});

document.addEventListener('DOMContentLoaded', () => {
 //Swiper (Backing Yourself)
    initSlider("#backing-yourself", {
      slidesPerView: 2,
      speed: 500,
	  loop: true,
      navigation: {
        nextEl: '#backing-yourself-next',
        prevEl: '#backing-yourself-prev',
       },
      pagination: {
        el: '#backing-yourself-pagination',
        bulletActiveClass: "is-active",
        bulletClass: "swiper_dots",
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 16
        },
        992: {
          slidesPerView: "auto",
          spaceBetween: 16
        }
      }
    });
});

document.addEventListener('DOMContentLoaded', () => {
 //Swiper (Blog)
    initSlider("#blog", {
      slidesPerView: 2,
      speed: 500,
	  loop: true,
      navigation: {
        nextEl: '#blog-next',
        prevEl: '#blog-prev',
       },
      pagination: {
        el: '#blog-pagination',
        bulletActiveClass: "is-active",
        bulletClass: "swiper_dots",
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1.05,
          spaceBetween: 16
        },
        992: {
          slidesPerView: "auto",
          spaceBetween: 16
        }
      }
    });
});


let mm = gsap.matchMedia();
mm.add("(min-width: 992px)", () => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".home_reason_section",
      start: "top top",
      end: "+=175%",
      scrub: true,
      pin: true,
      toggleActions: "play pause resume reverse",
      // 👆 removed snap
    }
  });
  const items = gsap.utils.toArray(".home_reason_grid_list-item");
  items.forEach((item, i) => {
    let content = item.querySelector(".home_reason_title");
    let image = item.querySelector(".home_reason_grid_image_wrapper");
    // Enter: highlight + fade in
    tl.to(content, { color: "#BE5C3E", duration: 1 })
      .to(image, { autoAlpha: 1, duration: 1 }, "<")
      // Hold
      .to({}, { duration: 1 });
    // Exit (except for last)
    if (i !== items.length - 1) {
      tl.to(content, { color: "#E8E4D9", duration: 1 })
        .to(image, { autoAlpha: 0, duration: 1 }, "<");
    }
  });
});
